<template>
  <card header='Multi-progress'>
    <svg-h-progress :series="series"></svg-h-progress>
  </card>
</template>

<script>
import Card from './Card.vue'
import SvgHProgress from '@/components/charts/svg/HProgress.vue'
import { colors } from '@/plugins/colors.js'

export default {
  components: {
    Card,
    SvgHProgress
  },
  data () {
    return {
      series: {
        style: {
          color: {
            progress: colors[2],
            total: colors[6]
          }
        },
        data: [
          { progress: { value: 23724205 }, total: { value: 142345234 }, label: 'Апр' },
          { progress: { value: 9362102 }, total: { value: 112345234 }, label: 'Май' },
          { progress: { value: 16543154 }, total: { value: 132345234 }, label: 'Июн' },
          { progress: { value: 25390872 }, total: { value: 152345234 }, label: 'Июл' },
          { progress: { value: 6156348 }, total: { value: 92345234 }, label: 'Авг' },
          { progress: { value: 28086308 }, total: { value: 112345234 }, label: 'Сен' },
          { progress: { value: 7695787 }, total: { value: 100045234 }, label: 'Окт' },
          { progress: { value: 8670436 }, total: { value: 104045234 }, label: 'Дек' },
          { progress: { value: 9574659 }, total: { value: 134045234 }, label: 'Янв' },
          { progress: { value: 14007539 }, total: { value: 84045234 }, label: 'Фев' },
          { progress: { value: 17720747 }, total: { value: 124045234 }, label: 'Мар' }
        ]
      },
      series2: {
        style: {
          color: {
            progress: colors[2],
            total: colors[6]
          }
        },
        data: [
          { progress: { value: 23724205 }, total: { value: 142345234 } },
          { progress: { value: 33724205 }, total: { value: 132345234 } }
        ]
      },
      series3: {
        style: {
          color: {
            progress: colors[2],
            total: colors[6]
          }
        },
        data: [
          { progress: { value: 23724205 }, total: { value: 142345234 } }
        ]
      }
    }
  }
}
</script>
